<template>
  <fieldset>
    <div :class="[$style.inputContainer, $style.full]">
      <InputValidator
        :config="{
          name: attribute,
          placeholder: 'Attribute',
          type: 'text',
          validate: 'max:1024|required',
          value: listItem,
        }"
        @InputValidatorModel="handleInputChange"
      />
    </div>
  </fieldset>
</template>
<script>
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'SingleListBoxFields',

  components: {
    InputValidator,
  },

  inject: ['$validator'],

  props: {
    addingItem: {
      type: Boolean,
      default: false,
    },
    handleChangeListItem: {
      type: Function,
      required: true,
    },
    index: {
      type: Number,
      default: undefined,
    },
    listItem: {
      type: String,
      required: true,
    },
  },

  computed: {
    /**
     * Create a unique name for the attribute name field so errors in this
     * field can be uniquely identified.
     */
    attribute() {
      return `attribute-${this.index}-name`;
    },
  },

  /**
   * Use field specific custom messages in vee-validate so that the unique
   * input names are not used in the error messages.
   * @see https://baianat.github.io/vee-validate/guide/messages.html#field-specific-custom-messages
   */
  mounted() {
    this.handleMounted();
  },

  methods: {
    handleInputChange(value) {
      this.handleChangeListItem(value);
    },

    handleMounted() {
      const vValidateDict = {
        custom: {
          [this.attribute]: {
            max: '* 1,024 character limit.',
            required: '* The attribute value field is required.',
          },
        },
      };

      this.$validator.localize('en', vValidateDict);
    },
  },
};
</script>
<style module scoped>
@import '../../../css/flex.css';

.inputContainer {
  display: inline-block;
  vertical-align: top;
}
</style>
